export const UPDATES = {
  // ============================================
  // CREATE RECOMMEND - WHO OPTIONS (001-019)
  // ============================================

  // components/Common/RecommendGoalsSelect.tsx
  // [RecommendGoalsSelect.tsx] GoalsSelect -> [CreateRecommendHeader.tsx] / [CreateRecommendSPPDAHeader.tsx] -> [CreateRecommendHelpers.tsx] CreateRecommend
  _012: '012: user selects goal from dropdown',
  // features/recommendations/CreateRecommend/RecommendWhoOptions/RecommendWhoOptions.tsx
  // [RecommendWhoOptions.tsx] -> [CreateRecommendHeader.tsx] / [CreateRecommendSPPDAHeader.tsx] -> [CreateRecommendHelpers.tsx] CreateRecommend
  _001: '001: Load contact from recommendDetails',
  _002: '002: Load contact from reviewDetails',
  _003: '003: Default contact to TRUST for trust account',
  _004: '004: Default contact to JOINT for joint account',
  _005: '005: Load ownership from recommendDetails',
  _006: '006: Load goal from recommendDetails',
  _007: '007: Load ownership WHOLE_FAMILY from recommendDetails',
  _008: '008: Load contact as TRUST for WHOLE_FAMILY ownership',
  _009: '009: Load contact from recommendDetails/reviewDetails/contacts',
  _010: '010: Derive ownership JOINT_LIVES from contact',
  _011: '011: Derive ownership SINGLE_LIVES from contact',
  _013: '013: Derive isMinor from selected contact',

  // ============================================
  // CREATE RECOMMEND - WHAT OPTIONS (020-039)
  // ============================================

  // features/recommendations/CreateRecommend/RecommendWhatOptions/RecommendWhatOptions.tsx
  // [RecommendWhatOptions.tsx] loadRecommendWhat -> [CreateRecommendHeader.tsx] / [CreateRecommendSPPDAHeader.tsx] -> [CreateRecommendHelpers.tsx] CreateRecommend
  _020: '020: Derive adviceWhat from planAction',
  // [RecommendWhatOptions.tsx] loadPlanActionFromRecommend (useLoadPlanActionFromRecommend) -> [CreateRecommendHeader.tsx] / [CreateRecommendSPPDAHeader.tsx] -> [CreateRecommendHelpers.tsx] CreateRecommend
  _021: '021: Load planAction from recommendDetails',

  // ============================================
  // CREATE RECOMMEND - HOW OPTIONS (040-059)
  // ============================================

  // features/recommendations/CreateRecommend/RecommendHowOptions/RecommendHowOptions.tsx
  // [RecommendHowOptions.tsx] -> [CreateRecommendHeader.tsx] -> [CreateRecommendHelpers.tsx] CreateRecommend
  _042: '042: Load how as Instruction from reviewDetails',
  _043: '043: Load how as Recommendation from reviewDetails',
  // features/recommendations/CreateRecommend/RecommendHowOptions/RecommendSPPOptions.tsx
  // [RecommendSPPOptions.tsx] -> [CreateRecommendSPPDAHeader.tsx] -> [CreateRecommendHelpers.tsx] CreateRecommend
  _040: '040: Load how type from recommendDetails',
  // features/recommendations/CreateRecommend/RecommendHowOptions/RecommendSPPOptions.tsx
  // [RecommendSPPOptions.tsx] -> [CreateRecommendSPPDAHeader.tsx] -> [CreateRecommendHelpers.tsx] CreateRecommend
  _041: '041: Default how to Instruction (SPP context)',

  // ============================================
  // CREATE RECOMMEND - WHEN OPTIONS (060-079)
  // ============================================

  // components/Common/Urgency.tsx
  // [Urgency.tsx] Urgency -> [TasksForm.tsx] Tasks (standalone) AND [RecommendWhenOptions.tsx] -> CreateRecommend
  _065: '065: Auto-set urgencyReason for Tax year end in Urgency component',
  // features/recommendations/CreateRecommend/RecommendWhenOptions/RecommendWhenOptions.tsx
  // [RecommendWhenOptions.tsx] loadUrgencyFromRecommend (useLoadUrgencyFromRecommend) -> [CreateRecommendHeader.tsx] / [CreateRecommendSPPDAHeader.tsx] -> [CreateRecommendHelpers.tsx] CreateRecommend
  _060: '060: Load urgency from recommendDetails',
  _061: '061: Load urgencyReason from recommendDetails',
  // [RecommendWhenOptions.tsx] loadUrgencyDefaults (useLoadUrgencyDefaults) -> RecommendsUrgency -> [CreateRecommendHeader.tsx] / [CreateRecommendSPPDAHeader.tsx] -> [CreateRecommendHelpers.tsx] CreateRecommend
  _062: '062: Default urgency to NORMAL',
  _063: '063: Auto-set urgencyReason for Tax year end',
  _064: '064: Clear urgencyReason',

  // ============================================
  // CREATE RECOMMEND - PLAN OPTIONS (080-099)
  // ============================================

  // features/recommendations/CreateRecommend/RecommendPlanOptions/RecommendPlanOptions.tsx
  // [RecommendPlanOptions.tsx] loadMainPlanType (useLoadMainPlanType) -> [CreateRecommendHeader.tsx] / [CreateRecommendSPPDAHeader.tsx] -> [CreateRecommendHelpers.tsx] CreateRecommend
  _080: '080: Load mainPlanType from recommendDetails',
  // [RecommendPlanOptions.tsx] deriveAdvicePlan (useDeriveAdvicePlan) -> [CreateRecommendHeader.tsx] / [CreateRecommendSPPDAHeader.tsx] -> [CreateRecommendHelpers.tsx] CreateRecommend
  _081: '081: Derive advicePlan from plan name',

  // ============================================
  // CREATE RECOMMEND - FREQUENCY (100-119)
  // ============================================

  // features/recommendations/CreateRecommend/useGetReccFrequency.tsx
  // [useGetReccFrequency.tsx] setFrequencyComboHelpers -> useGetReccFrequency -> [Contribute.tsx]
  // [useGetReccFrequency.tsx] setFrequencyComboHelpers -> useGetReccFrequency -> [Transfer.tsx] Transfer
  // [useGetReccFrequency.tsx] setFrequencyComboHelpers -> useGetReccFrequency -> [Withdrawal.tsx] Withdrawal
  // [useGetReccFrequency.tsx] setFrequencyComboHelpers -> useGetReccFrequency -> [NewPlan.tsx] NewPlan -> [SetUpNew.tsx] SetUpNew
  _100: '100: Load comboFrequency (aka single and/or monthly/yearly) from recommendation',
  _101: '101: Set default frequency combo to single if no existing recommendation',
  _102: '102: Set default frequency combo to single if the existing recommendation has no frequency',
  _103: '103: Set frequency from comboFrequency. TODO: can be calculated by reducer pattern',

  // ============================================
  // CREATE RECOMMEND - RESET RECCS (120-139)
  // ============================================

  // features/recommendations/CreateRecommend/RecommendSourceDestination/useResetReccs.ts
  // [useResetReccs.ts] useResetReccs -> [Contribute.tsx] Contribute
  // [useResetReccs.ts] useResetReccs -> [Transfer.tsx] Transfer
  // [useResetReccs.ts] useResetReccs -> [Withdrawal.tsx] Withdrawal
  // [useResetReccs.ts] useResetReccs -> [SetUpNew.tsx] SetUpNew
  // [useResetReccs.ts] useResetReccs -> [RecommendModify.tsx] RecommendModify
  // [useResetReccs.ts] useResetReccs -> [RecommendsAction.tsx] RecommendsAction
  // [useResetReccs.ts] useResetReccs -> [RecommendAdHocFee.tsx] RecommendAdHocFee
  _120: '120: Reset contribute on plan action change',
  _121: '121: Reset withdraw on plan action change',
  _122: '122: Reset transfer on plan action change',
  _123: '123: Reset newPlan on plan action change',
  _124: '124: Reset adHocFee on plan action change',

  // ============================================
  // CREATE RECOMMEND - ACTION (160-179)
  // ============================================

  // features/recommendations/RecommendsAction/RecommendsAction.tsx
  // [RecommendsAction.tsx] loadActionNotes (useLoadActionNotes) -> RecommendsAction (top-level)
  _160: '160: Load action notes',

  // ============================================
  // CONTRIBUTE
  // ============================================

  // features/recommendations/RecommendsContribute/ContributeHelpers.tsx
  // [ContributeHelpers.tsx] changeContributeFromFactory -> [Contribute.tsx] Contribute
  // [ContributeHelpers.tsx] changeContributeToFactory -> [Contribute.tsx] Contribute
  _291: '291: Load AND update: if there is a cash pot associated with the recc, set contribute.cashPotId to pot id. TODO: NOT SURE IF WE SHOULD DO THIS?',
  _292: '292: Load AND update: set contribute source based on existing source put in recc. TODO: SEPARATE',
  _293: '293: Load AND update contribute destination plan, destination values, destination subplans, cashPotId, and plan provider (TODO: not sure why not in destination values). TODO: SEPARATE',
  _315: '315: Builder: Load saved contribute from builderDetails',
  // features/recommendations/RecommendsContribute/ContributeSources.tsx
  // [ContributeSources.tsx] loadContributeFrequency (useLoadContributeFrequency) -> [ContributeHelpers.tsx] getContributeFromChoices -> [Contribute.tsx] Contribute
  _270: '270: Load frequency from recommendDetails pots (probably not needed)',
  // [ContributeSources.tsx] deriveIsLisaContribute (useDeriveIsLisaContribute) -> [ContributeHelpers.tsx] getContributeFromChoices -> [Contribute.tsx] Contribute
  _271: '271: Derive isLisa flag for contribute destination',
  _272: '272: Clear initialFee for LISA contribution',
  // [ContributeSources.tsx] setContributeFullAmount (useSetContributeFullAmount) -> [ContributeHelpers.tsx] getContributeFromChoices -> [Contribute.tsx] Contribute
  _288: '288: Set full contribution amount if user checks full',
  // [ContributeSources.tsx] calculateNetRecurringClient (useCalculateNetRecurringClient) -> [ContributeHelpers.tsx] getContributeFromChoices -> [Contribute.tsx] Contribute
  _290: '290: Contribute: Set net recurring client amount (80% of gross)',
  // [ContributeSources.tsx] calculateNetSingleClient (useCalculateNetSingleClient) -> [ContributeHelpers.tsx] getContributeFromChoices -> [Contribute.tsx] Contribute
  _278: '278: Contribute: Calculate net single client (80% of gross)',
  // features/recommendations/RecommendsContribute/ContributeSourcesHelpers.tsx
  // [ContributeSourcesHelpers.tsx] -> [ContributeSources.tsx] ContributeSources -> [ContributeHelpers.tsx] -> [Contribute.tsx] Contribute
  _268: '268: Default contribute start date to minimum (no current date)',
  _269: '269: Update contribute start date to minimum',
  _276: '276: Sync destination recurring employer amount',
  _277: '277: Set full contribution amount',
  _279: '279: Contribute: Calculate net recurring client (80% of gross)',
  _280: '280: Contribute: Sync contributeFrom amounts to new-plan subplan fields',
  // features/recommendations/RecommendsContribute/useContributeAmounts.tsx
  // [useContributeAmounts.tsx] useContributeAmounts -> [Contribute.tsx] Contribute
  _294: '294: If not single frequency, reset single employer amount',
  _295: '295: If not single frequency, reset single client amount',
  _296: '296: If not recurring frequency, reset recurring client amount',
  _297: '297: If not recurring frequency, reset recurring employer amount',
  // features/recommendations/RecommendsContribute/useContributeAmountsHelpers.tsx
  // [useContributeAmountsHelpers.tsx] -> [useContributeAmounts.tsx] useContributeAmounts -> [Contribute.tsx] Contribute
  _254: '254: Calculate combinedOneOffMovingAmount',
  _255: '255: Calculate combinedRecurringMovingAmount',
  _256: '256: Calculate combinedEmployersOneOffMovingAmount',
  _257: '257: Calculate combinedEmployersRecurringMovingAmount',
  _258: '258: Calculate combinedClientRecurringMovingAmount',
  _259: '259: Calculate combinedClientOneOffMovingAmount',
  _260: '260: Sync destinationValues.singleClientAmount',
  _261: '261: Sync destinationValues.recurringClientAmount',
  _262: '262: Sync destinationValues.singleEmployerAmount',
  _263: '263: Sync destinationValues.recurringEmployerAmount',
  _264: '264: Calculate newPlan subplan0 amount minus subplan1',
  _265: '265: Sync single existing subplan amount',
  _266: '266: Calculate first subplan amount minus other subplans',
  _267: '267: Sync destinationValues amount when no subplans',

  // ============================================
  // WITHDRAWAL (3400-3449)
  // ============================================

  // features/recommendations/RecommendsWithdrawal/WithdrawalHelpers.tsx
  // [WithdrawalHelpers.tsx] -> [Withdrawal.tsx] Withdrawal
  _3404: '3404: Change withdrawal source',
  _3405: '3405: Change withdrawal destination',
  _3406: '3406: Set new withdrawal destination (load)',
  _3407: '3407: Load saved withdrawal source',

  // ============================================
  // WITHDRAWAL - SOURCES (300-349)
  // ============================================

  // features/recommendations/RecommendsWithdrawal/WithdrawalSources.tsx
  // [WithdrawalSources.tsx] handleWithdrawalFullAndReason (useHandleWithdrawalFullAndReason) -> [WithdrawalHelpers.tsx] -> [Withdrawal.tsx] Withdrawal
  _300: '300: Load withdraw reason from recommendDetails',
  _301: '301: default frequency for withdrawal if no existing recommendation',
  _302: '302: default comboFrequency for withdrawal if no existing recommendation',
  _303: '303: Clear withdraw reason',
  // features/recommendations/RecommendsWithdrawal/WithdrawalSourcesHelpers.tsx
  // [WithdrawalSourcesHelpers.tsx] -> [WithdrawalSources.tsx] -> [WithdrawalHelpers.tsx] -> [Withdrawal.tsx] Withdrawal
  _304: '304: Load withdraw source details from recommendDetails',
  _306: '306: Set full withdrawal amount as user checked full',
  _307: '307: Set partial withdrawal amount as either: user unchecked full; or is default',
  _308: '308: Load withdrawal frequency from existing recommendation TODO: LIKELY NOT NEEDED',
  _309: '309: Load withdrawal comboFrequency from existing recommendation TODO: LIKELY NOT NEEDED',
  _310: '310: Load withdrawal start date from existing recommendation',
  _311: '311: Load withdrawal reason from existing source pot',
  _312: '312: Load withdrawal single client amount from existing source pot',
  _313: '313: Load withdrawal recurring client amount from existing source pot',
  _314: '314: Load withdrawal initial fee from existing source pot',

  // ============================================
  // WITHDRAWAL - DESTINATION (350-399)
  // ============================================

  // features/recommendations/RecommendsWithdrawal/NewCurrentAccountDetails.tsx
  // [NewCurrentAccountDetails.tsx] -> [WithdrawalHelpers.tsx] -> [Withdrawal.tsx] Withdrawal
  _351: '351: Load withdraw destination accountNumber from pot',
  _352: '352: Load withdraw destination ownership from pot',
  _353: '353: Load withdraw destination productProvider from pot',
  _354: '354: Load withdraw destination accountName from pot',
  _355: '355: Load withdraw destination sortCode from pot',
  _356: '356: Set bankDetails NEED_VALIDATING from pot',
  _357: '357: Set bankDetails NOT_KNOWN from pot. incomplete/"00-00-00" inputs',
  _359: '359: Update sort code manually',

  // ============================================
  // TRANSFER - SOURCES (400-449)
  // ============================================

  // features/recommendations/RecommendsTransfer/Transfer.tsx
  // [Transfer.tsx] initTransferDefaults (useInitTransferDefaults) -> Transfer (top-level)
  _402: '402: Transfer: Init isPensionSharing flag to false',
  _403: '403: Transfer: Init isDependantsPension flag to false',
  _404: '404: Transfer: Init isAps flag to false',
  // [Transfer.tsx] resetTransferSourcesOnPlanTypeChange (useResetTransferSourcesOnPlanTypeChange) -> Transfer (top-level)
  _406: '406: Reset transfer sources when plantype changes',
  // [Transfer.tsx] changeTransferDestination -> Transfer (top-level)
  _407: '407: Change transfer destination',
  _410: '410: Change destination values on user selecting destination',
  // [Transfer.tsx] resetDestinationIfInSources (useResetDestinationIfInSources) -> Transfer (top-level)
  _408: '408: Clear transfer destination when source is changed',
  // [Transfer.tsx] addShellSourcePlan -> Transfer (top-level)
  _409: '409: Add new shell source',
  // features/recommendations/RecommendsTransfer/TransferHelpers.tsx
  // [TransferHelpers.tsx] -> [Transfer.tsx] Transfer
  _401: '401: User has checked new transfer source',
  _411: '411: LOAD WHOLE saved transfer',
  // features/recommendations/RecommendsTransfer/useTransferAmounts.tsx
  // [useTransferAmounts.tsx] useTransferAmounts -> [Transfer.tsx] Transfer
  _413: '413: Transfer set first subplan amount to full amount (no other subplans)',
  // features/recommendations/RecommendsTransfer/TransferSourceForm.tsx
  // [TransferSourceForm.tsx] deriveIsLisaTransferSource (useDeriveIsLisaTransferSource) -> [TransferHelpers.tsx] -> [Transfer.tsx] Transfer
  // [TransferSourceForm.tsx] deriveIsLisaTransferSource (useDeriveIsLisaTransferSource) -> [AnnuityPlan.tsx] -> [SetUpNew.tsx] SetUpNew
  _405: '405: Set global isLisa flag if plan is lifetime ISA. TODO: used for recommendation name, probably take out',
  // [TransferSourceForm.tsx] setTransferFullAmount (useSetTransferFullAmount) -> [TransferHelpers.tsx] -> [Transfer.tsx] Transfer
  _414: '414: Transfer set full transfer amount when user checks "full transfer"',
  // features/recommendations/RecommendsTransfer/useTransferAmounts.tsx
  // [useTransferAmounts.tsx] useTransferAmounts -> [Transfer.tsx] Transfer
  _412: '412: Update first subplan transfer amount (minus second subplan destination from total transfer amount)',

  // ============================================
  // TRANSFER - AMOUNTS (450-499)
  // ============================================

  // features/recommendations/RecommendsTransfer/TransferHelpers.tsx
  // [TransferHelpers.tsx] setTransferCombinedAmounts -> [Transfer.tsx] Transfer
  _450: '450: Calculate transfer combinedOneOffMovingAmount by adding all sources',
  _451: '451: Calculate transfer combinedClientOneOffMovingAmount by adding all sources. TODO: likely redundant, due to trying to also use contribute calculations. See if can be removed.',

  // ============================================
  // CONTRIBUTE AND TRANSFER SHARED
  // ============================================

  // features/recommendations/RecommendsTransfer/TransferExistingSubplans.tsx
  // [TransferExistingSubplans.tsx] -> [TransferHelpers.tsx] -> [Transfer.tsx] Transfer
  // features/recommendations/RecommendsContribute/ContributeExistingSubplans.tsx
  // [ContributeExistingSubplans.tsx] -> [ContributeHelpers.tsx] -> [Contribute.tsx] Contribute
  _519: '519: User has toggled existing subplan checked state',
  // features/recommendations/RecommendsSetUpNew/ListNewSubPlans.tsx
  // [ListNewSubPlans.tsx] toggleSubPlanChecked -> [NewPlan.tsx] NewPlan -> [SetUpNew.tsx] SetUpNew
  // [ListNewSubPlans.tsx] toggleSubPlanChecked -> [NewPlan.tsx] NewPlan -> [TransferHelpers.tsx] -> [Transfer.tsx] Transfer
  // [ListNewSubPlans.tsx] toggleSubPlanChecked -> [NewPlan.tsx] NewPlan -> [ContributeHelpers.tsx] -> [Contribute.tsx] Contribute
  _460: "460: Contribute + Transfer: User toggles (aka checks/unchecks) new plan's subplan",
  // [ListNewSubPlans.tsx] ensureFirstSubPlanSelected (useEnsureFirstSubPlanSelected) -> [NewPlan.tsx] NewPlan -> [SetUpNew.tsx] SetUpNew
  _461: '461: Contribute + Transfer: If subplan doesnt have a saltus parent/wrapper, force subplan0 (first subplan) to be checked. TODO: This WrappedNewSubPlans is a mess and needs to be taken out',

  // ============================================
  // NEW PLAN - SHARED WITH SETUP NEW, CONTRIBUTE, TRANSFER
  // ============================================

  // features/recommendations/CreateRecommend/useSPPProviders.tsx
  // [useSPPProviders.tsx] -> [NewPlanForm.tsx] -> [NewPlan.tsx] NewPlan -> [SetUpNew.tsx] SetUpNew
  // [useSPPProviders.tsx] -> [NewSubPlanDetails.tsx] -> [ListNewSubPlans.tsx] -> [NewPlan.tsx] NewPlan
  _522: "522: SPP Only: New plan or New shell plan, set default plan provider saltus provider based on backend API and selecting 'favourite' provider",
  // features/recommendations/RecommendsSetUpNew/NewPlan.tsx
  // [NewPlan.tsx] deriveIsLowesPension (useDeriveIsLowesPension) -> [SetUpNew.tsx] SetUpNew
  // [NewPlan.tsx] deriveIsLowesPension (useDeriveIsLowesPension) -> [TransferHelpers.tsx] -> [Transfer.tsx] Transfer
  // [NewPlan.tsx] deriveIsLowesPension (useDeriveIsLowesPension) -> [ContributeHelpers.tsx] -> [Contribute.tsx] Contribute
  _500: '500: New plan, set global isLowesPension flag from new plan provider',
  // [NewPlan.tsx] deriveIsTransactBond (useDeriveIsTransactBond) -> [SetUpNew.tsx] SetUpNew
  // [NewPlan.tsx] deriveIsTransactBond (useDeriveIsTransactBond) -> [TransferHelpers.tsx] -> [Transfer.tsx] Transfer
  // [NewPlan.tsx] deriveIsTransactBond (useDeriveIsTransactBond) -> [ContributeHelpers.tsx] -> [Contribute.tsx] Contribute
  _501: '501: New plan, set global isTransactBond flag from new plan provider',
  // features/recommendations/RecommendsSetUpNew/NewPlanForm.tsx
  // [NewPlanForm.tsx] updateIsSaltusProvider (useUpdateIsSaltusProvider) -> [NewPlan.tsx] NewPlan -> [SetUpNew.tsx] SetUpNew
  _525: '525: Set global isSaltusProvider flag if new plan destination is saltus product',
  // [NewPlanForm.tsx] clearMandateOnProviderBlur -> [NewPlan.tsx] NewPlan -> [SetUpNew.tsx] SetUpNew
  _526: '526: Clear mandate on plan provider blur',
  // [NewPlanForm.tsx] deriveIsNewLisa (useDeriveIsNewLisa) -> [NewPlan.tsx] NewPlan -> [SetUpNew.tsx] SetUpNew
  _502: '502: Set global isLisa flag for new plan',
  // [NewPlanForm.tsx] setDefaultSaltusSippPlanType (useSetDefaultSaltusSippPlanType) -> [NewPlan.tsx] NewPlan -> [SetUpNew.tsx] SetUpNew
  _504: '504: Default planType for new plan',
  // features/recommendations/RecommendsSetUpNew/NewPlanHelpers.tsx
  // [NewPlanHelpers.tsx] -> [NewPlanForm.tsx] -> [NewPlan.tsx] NewPlan -> [SetUpNew.tsx] SetUpNew
  // [NewPlanHelpers.tsx] -> [NewPlanForm.tsx] -> [NewPlan.tsx] NewPlan -> [TransferHelpers.tsx] -> [Transfer.tsx] Transfer
  // [NewPlanHelpers.tsx] -> [NewPlanForm.tsx] -> [NewPlan.tsx] NewPlan -> [ContributeHelpers.tsx] -> [Contribute.tsx] Contribute
  _503: '503: Clear planType on provider change',
  _505: '505: Load existingPotId from parent pot',
  _506: '506: Load inTrust from parent pot',
  _507: '507: Load planType from parent pot',
  _508: '508: Load planProvider from parent pot',
  _509: '509: Load planFees from parent pot',
  _510: '510: Load model from parent pot',
  _511: '511: Init subplan0 checked from children',
  _512: '512: Init subplan1 checked from children',
  _513: '513: Load existingPotId from destination pot',
  _514: '514: Load inTrust from destination pot',
  _515: '515: Load planType from recommendDetails',
  _516: '516: Load planProvider from recommendDetails',
  _517: '517: Load planFees from destination pot',
  _518: '518: Load model from destination pot',
  // features/recommendations/RecommendsSetUpNew/NewSubPlanDetails.tsx
  // [NewSubPlanDetails.tsx] -> [ListNewSubPlans.tsx] -> [NewPlan.tsx] NewPlan -> [SetUpNew.tsx] SetUpNew
  _527: '527: Clear new subplan mandate on blur',
  // features/recommendations/RecommendsSetUpNew/ProtectionPlan.tsx
  // [ProtectionPlan.tsx] -> [SetUpNew.tsx] SetUpNew
  _520: '520: Load protection plan values from existing recommendation',
  _521: '521: Update term value',
  // features/recommendations/RecommendsSetUpNew/SetUpNew.tsx
  // [SetUpNew.tsx] loadSavedSetUpNewPlan (useLoadSavedSetUpNewPlan) -> SetUpNew (top-level)
  _524: '524: Load new plan values and new subplan values from recommendDetails',
  _678: '678: Use default values for new plan and subplan when no recommendDetails',
  // features/recommendations/RecommendsSetUpNew/SetupNewConvert.tsx
  // [SetupNewConvert.tsx] convertNewPlanToContributeFactory -> SetupNewConvert
  _528: '528: Convert new plan to contribute',
  // [SetupNewConvert.tsx] convertNewPlanToTransferFactory -> SetupNewConvert
  _529: '529: Convert new plan to transfer',
  // [BuilderListNewSubPlans.tsx] handleAddSubplan -> BuilderWrappedNewSubPlans -> BuilderSetUpNew
  _530: '530: SetUpNew: Add new subplan to subplans array',
  // [BuilderListNewSubPlans.tsx] handleRemoveSubplan -> BuilderWrappedNewSubPlans -> BuilderSetUpNew
  _531: '531: SetUpNew: Remove new subplan from subplans array',
  // [BuilderNewSubPlanDetails.tsx] useEffect sync -> BuilderWrappedNewSubPlans -> BuilderSetUpNew
  _532: '532: SetUpNew: Sync subplan planProvider to parent planProvider',
  _533: '533: SetUpNew: Sync subplan productNameId to parent productNameId',

  // ============================================
  // MANDATE - SHARED WITH SET UP NEW, MODIFY (1600-1699)
  // ============================================

  // pages/MandatesPage/Mandates.tsx
  // [Mandates.tsx] Mandates -> [MandatesModal.tsx] MandatesWrapper -> [ModifyFields.tsx] / [NewPlanForm.tsx] / [NewSubPlanDetails.tsx]
  _1609:
    '1609: Mandate: After user has selected mandate risk and portfolio, reset temporary model value (inside modal) to null if there are multiple available models',
  _1610:
    '1610: Mandate: After user has selected mandate risk and portfolio, set temporary model value (inside modal) if theres only one available model',
  // pages/MandatesPage/MandatesModal.tsx
  // [MandatesModal.tsx] MandatesWrapper -> [ModifyFields.tsx] -> [RecommendModify.tsx] RecommendModify
  // [MandatesModal.tsx] MandatesWrapper -> [NewPlanForm.tsx] -> [NewPlan.tsx] NewPlan -> [SetUpNew.tsx] SetUpNew
  // [MandatesModal.tsx] MandatesWrapper -> [NewSubPlanDetails.tsx] -> [ListNewSubPlans.tsx] -> [NewPlan.tsx] NewPlan
  _1606: '1606: Set mandate model temp',
  _1607: '1607: Set mandate model',
  _1608: '1608: Clear plan fees on mandate submit',

  // ============================================
  // NEW PLAN AND SHELL PLAN SHARED (550-599)
  // ============================================

  // features/recommendations/RecommendsSetUpNew/PlanContactField.tsx
  // [PlanContactField.tsx] setDefaultPlanContact (useSetDefaultPlanContact) -> [NewCurrentAccountDetails.tsx] -> [WithdrawalHelpers.tsx] -> [Withdrawal.tsx] Withdrawal
  // [PlanContactField.tsx] setDefaultPlanContact (useSetDefaultPlanContact) -> [ShellPlan.tsx] -> [TransferHelpers.tsx] -> [Transfer.tsx] Transfer
  // [PlanContactField.tsx] setDefaultPlanContact (useSetDefaultPlanContact) -> [NewPlanForm.tsx] -> [NewPlan.tsx] NewPlan -> [SetUpNew.tsx] SetUpNew
  _550: '550: Set default plan contact ID (single contact)',

  // ============================================
  // TRANSFER - SHELL PLAN (600-649)
  // ============================================

  // features/recommendations/RecommendsSetUpNew/ShellPlan.tsx
  // [ShellPlan.tsx] deriveIsLisaShellPlan (useDeriveIsLisaShellPlan) -> [TransferHelpers.tsx] -> [Transfer.tsx] Transfer
  _600: '600: TODO: This sets global isLisa (aka lifetime ISA *destination*), but inside a shell *source*',
  // [ShellPlan.tsx] setDefaultShellPlanType (useSetDefaultShellPlanType) -> [TransferHelpers.tsx] -> [Transfer.tsx] Transfer
  _601: '601: Set default shell plan type if no recc exists after fetching shell plan types',
  // [ShellPlan.tsx] setShellFullAmount (useSetShellFullAmount) -> [TransferHelpers.tsx] -> [Transfer.tsx] Transfer
  _602: '602: Set shell plan amount to entire plan value if full transfer',

  // ============================================
  // MODIFY (650-699)
  // ============================================

  // features/recommendations/RecommendModify/ModifyFields.tsx
  // [ModifyFields.tsx] -> [RecommendModify.tsx] RecommendModify
  _663: '663: If not a model change modify recc, then reset form plan fee modifications to null',
  // features/recommendations/RecommendModify/RecommendModify.tsx
  // [RecommendModify.tsx] RecommendModify (top-level)
  _650: '650: Derive modify.planProvider from selected source',
  _651: '651: Derive modify.planType from selected source',
  _652: '652: Derive modify.existingModel from selected source',
  _653: '653: Clear modify.planProvider',
  _654: '654: Clear modify.planType',
  _655: '655: Clear modify.existingModel',
  _660: '660: Init modify values (empty)',
  _661: '661: Init modify values (from details)',
  _662: '662: Update modify source',

  // ============================================
  // ANNUITY (700-749)
  // ============================================

  // features/recommendations/RecommendsSetUpNew/AnnuityPlan.tsx
  // [AnnuityPlan.tsx] -> [SetUpNew.tsx] SetUpNew
  _700: '700: Init annuity values (empty)',
  _701: '701: Load annuity values (from details)',
  _702: '702: Update annuity source',
  _703: '703: Init transfer sources for annuity',
  _704: '704: Reset transfer for annuity',

  // ============================================
  // TRANSFER DESTINATION AMOUNTS (900-909)
  // ============================================

  // features/recommendations/CreateRecommend/RecommendSourceDestination/TransferNotSubplanDestinationAmounts.tsx
  // [TransferNotSubplanDestinationAmounts.tsx] -> [TransferHelpers.tsx] -> [Transfer.tsx] Transfer
  // features/recommendations/CreateRecommend/RecommendSourceDestination/TransferSubplanDestinationAmounts.tsx
  // [TransferSubplanDestinationAmounts.tsx] -> [TransferExistingSubplans.tsx] -> [TransferHelpers.tsx] -> [Transfer.tsx] Transfer
  _900: '900: Set destination plan provider',
  _901: '901: Set destination single client amount',

  // ============================================
  // CONTRIBUTE DESTINATION AMOUNTS (900-904)
  // ============================================

  // features/recommendations/CreateRecommend/RecommendSourceDestination/ContributeNotSubplanDestinationAmounts.tsx
  // [ContributeNotSubplanDestinationAmounts.tsx] -> [ContributeHelpers.tsx] -> [Contribute.tsx] Contribute
  // features/recommendations/CreateRecommend/RecommendSourceDestination/ContributeSubplanDestinationAmounts.tsx
  // [ContributeSubplanDestinationAmounts.tsx] -> [ContributeExistingSubplans.tsx] -> [ContributeHelpers.tsx] -> [Contribute.tsx] Contribute
  // _900: (shared) Set destination plan provider
  // _901: (shared) Set destination single client amount
  _902: '902: Set destination recurring client amount',
  _903: '903: Set destination recurring employer amount',
  _904: '904: Set destination single employer amount',
  _905: '905: Set destination subplan existingPotId',

  // ============================================
  // SPP DA INITIAL FEES (1500-1549)
  // ============================================

  // features/recommendations/CreateRecommend/DAInitialFees.tsx
  // [DAInitialFees.tsx] DAInitialFeeField -> [InitialFeesField.tsx] -> [TransferSourceForm.tsx] -> [TransferHelpers.tsx] -> [Transfer.tsx] Transfer
  // [DAInitialFees.tsx] DAInitialFeeField -> [InitialFeesField.tsx] -> [ContributeSources.tsx] -> [ContributeHelpers.tsx] -> [Contribute.tsx] Contribute
  // [DAInitialFees.tsx] DAInitialFeeField -> [InitialFeesField.tsx] -> [ShellPlan.tsx] -> [TransferHelpers.tsx] -> [Transfer.tsx] Transfer
  _1500: '1500: Reset fixed fee',
  _1501: '1501: Reset percentage fee',
  _1502: '1502: Set default fixed fee',
  _1503: '1503: Set default percentage fee',
  _1504: '1504: Set fee type',
  _1505: '1505: Set valid percentage fee',

  // ============================================
  // RECURRING FEES (4000-4049)
  // ============================================

  // features/recommendations/CreateRecommend/FeeField.tsx
  // [FeeField.tsx] ongoingFeeField -> [AccountForm.tsx] AccountForm (standalone)
  _4017: '4017: Clear fee helpers for LISA',
  _4018: '4018: if no loaded ongoingfee on the recommendation, use account ongoing fee',
  // features/recommendations/CreateRecommend/PlanFees.tsx
  // [PlanFees.tsx] PlanFeesField -> [TransferNotSubplanDestinationAmounts.tsx] / [TransferSubplanDestinationAmounts.tsx] -> [Transfer.tsx]
  // [PlanFees.tsx] PlanFeesField -> [ContributeNotSubplanDestinationAmounts.tsx] / [ContributeSubplanDestinationAmounts.tsx] -> [Contribute.tsx]
  // [PlanFees.tsx] PlanFeesField -> [NewPlanForm.tsx] -> [NewPlan.tsx] NewPlan -> [SetUpNew.tsx] SetUpNew
  // [PlanFees.tsx] PlanFeesField -> [NewSubPlanDetails.tsx] -> [ListNewSubPlans.tsx] -> [NewPlan.tsx] NewPlan
  _4010: '4010: Set product fee required based on plan, if not modify',
  _4011: '4011: Set FP fee required based on plan, if not modify',
  _4012: '4012: Set DFM fee required based on plan, if not modify',
  _4013: '4013: Load fee deviation status',
  _4014: '4014: Auto-set DFM fee ID if only one available',
  _4015: '4015: Auto-set product fee ID if only one available',
  _4016: '4016: Auto-set FP fee ID if only one available',

  // ============================================
  // ADHOC FEES (3350-3352)
  // ============================================

  // NON RECOMMENDATIONS

  // features/recommendations/RecommendAdHocFee/RecommendAdHocFee.tsx
  // [RecommendAdHocFee.tsx] RecommendAdHocFee (top-level)
  _3350: '3350: Initialize adhoc fee (empty)',
  _3351: '3351: Initialize adhoc fee (from details)',
  _3352: '3352: Change adhoc source when user clicks source',

  // ============================================
  // HANDOVER (4100-4119)

  // pages/HandoverNotesPage/NotesEditorV2.tsx
  // [NotesEditorV2.tsx] -> [HandoverNotesInner.tsx] -> [HandoverNotes.tsx] HandoverNotes (page)
  _4100: '4100: Handover Notes - Set reviewed false (add note)',
  // pages/HandoverNotesPage/NotesEditorV2.tsx
  // [NotesEditorV2.tsx] -> [HandoverNotesInner.tsx] -> [HandoverNotes.tsx] HandoverNotes (page)
  _4101: '4101: Handover Notes - Set markup body (autosave)',
  // pages/HandoverNotesPage/NotesMenuItem.tsx
  // [NotesMenuItem.tsx] -> [NotesSideMenu.tsx] -> [HandoverNotesInner.tsx] -> [HandoverNotes.tsx] HandoverNotes (page)
  _4102: '4102: Handover Notes - Toggle reviewed status (menu item)',
  // pages/HandoverNotesPage/NotesSideMenu.tsx
  // [NotesSideMenu.tsx] -> [HandoverNotesInner.tsx] -> [HandoverNotes.tsx] HandoverNotes (page)
  _4103: '4103: Handover Notes - Set all reviewed status (side menu select all)',

  // ============================================
  // MANAGE STAKEHOLDERS (4160-4179)
  // ============================================

  // pages/ManageStakeholdersPage/ManageClientsPage.tsx
  // [ManageClientsPage.tsx] ManageClientsPage (page)
  _4162: '4162: Manage Clients - Clear account ID',
  _4163: '4163: Manage Clients - Clear delete input (Account and Contact)',
  _4164: '4164: Manage Clients - Clear delete input (Contact)',

  // ============================================
  // CONTACT PAGE (4300-4399)
  // ============================================

  // components/ContactPage/SimpleVulnerabilityFields.tsx
  // [SimpleVulnerabilityFields.tsx] -> [ContactPage.tsx] ContactPage (page)
  _4300: '4300: Contact Page - Set vulnerable status',
  _4301: '4301: Contact Page - Set event vulnerable status',
  _4302: '4302: Contact Page - Set long term vulnerability types',
  _4303: '4303: Contact Page - Set event vulnerability types',

  // ============================================
  // REVIEW SUBMISSION MODALS (4400-4499)
  // ============================================

  // components/RmAndJaSubmitDialog/RmAndJaSubmitDialog.tsx
  // [RmAndJaSubmitDialog.tsx] RmAndJaSubmitDialog (standalone)
  _4400: '4400: Set empty meeting date if meeting isnt booked',
  // pages/HandoverSummaryPage/HandoverRelationshipManagerModals.tsx
  // [HandoverRelationshipManagerModals.tsx] HandoverRelationshipManagerModals (page)
  _4401: '4401: Set meeting date null if meeting isnt booked',

  // ============================================
  // NEW ACCOUNT (4500-4599)
  // ============================================

  // pages/AddExtAccountPage/AddExtAccountAddress.tsx
  // [AddExtAccountAddress.tsx] AddExtAccountAddress (page)
  _4500: '4500: Set new account address line 1',

  // ============================================
  // EMAIL AUDIT (4600-4699)
  // ============================================

  // pages/EmailAuditPage/EmailAuditPage.tsx
  // [EmailAuditPage.tsx] EmailAuditPage (page)
  _4600: '4600: Set email audit page',

  // ============================================
  // RISK (1000-1099)
  // ============================================

  // features/risk/RiskForm.tsx
  // [RiskForm.tsx] RiskFormWrappedContainer -> [RiskPage.tsx] RiskPage (page)
  _1010: '1010: Set risk no discussion',
  // features/risk/RiskNoChange.tsx
  // [RiskNoChange.tsx] -> [RiskForm.tsx] -> [RiskPage.tsx] RiskPage (page)
  _1000: '1000: Set risk no change reason note',
  // features/risk/RiskOutcomeContact.tsx
  // [RiskOutcomeContact.tsx] -> [RiskForm.tsx] -> [RiskPage.tsx] RiskPage (page)
  _1006: '1006: Set risk outcome note',
  _1007: '1007: Set risk outcome score',
  // features/risk/RiskProfile.tsx
  // [RiskProfile.tsx] -> [RiskForm.tsx] -> [RiskPage.tsx] RiskPage (page)
  _1011: '1011: Set risk RTQ declined reason',
  // features/risk/RiskSection.tsx
  // [RiskSection.tsx] RiskFormSection -> [RiskForm.tsx] -> [RiskPage.tsx] RiskPage (page)
  _1001: '1001: Set risk section notes',
  _1002: '1002: Set risk section score',
  _1003: '1003: Toggle risk section noChange from side menu',
  _1004: '1004: Set risk section multiscore',
  _1005: '1005: Set risk section value (reset)',

  // ============================================
  // GOALS (1100-1199)
  // ============================================

  // features/goals/Goals/GoalAmounts.tsx
  // features/goals/Goals/GoalAmountsHelper.tsx
  // [GoalAmounts.tsx] -> [GoalFormHelper.tsx] -> [GoalForm.tsx] -> [CreateGoal.tsx] CreateGoal (page)
  // [GoalAmountsHelper.tsx] -> [GoalAmounts.tsx] -> [GoalFormHelper.tsx] -> [GoalForm.tsx] -> [CreateGoal.tsx] CreateGoal (page)
  _1109: '1109: Set goal target age',
  // features/goals/Goals/GoalAmountsHelper.tsx
  // [GoalAmountsHelper.tsx] -> [GoalAmounts.tsx] -> [GoalFormHelper.tsx] -> [GoalForm.tsx] -> [CreateGoal.tsx] CreateGoal (page)
  _1107: '1107: Set goal amount output',
  _1108: '1108: Set goal target end date',
  _1110: '1110: Set goal target years',
  // features/goals/Goals/GoalPriorities.tsx
  // [GoalPriorities.tsx] -> [GoalFormHelper.tsx] -> [GoalForm.tsx] -> [CreateGoal.tsx] CreateGoal (page)
  _1111: '1111: Set goal status at review',
  _1112: '1112: Set goal priority',
  // features/goals/Goals/GoalReasons.tsx
  // [GoalReasons.tsx] -> [GoalFormHelper.tsx] -> [GoalForm.tsx] -> [CreateGoal.tsx] CreateGoal (page)
  _1113: '1113: User typing goal description',
  // features/goals/Goals/GoalReasonsHelper.tsx
  // [GoalReasonsHelper.tsx] -> [GoalReasons.tsx] / [GoalAmounts.tsx] -> [GoalFormHelper.tsx] -> [GoalForm.tsx] -> [CreateGoal.tsx] CreateGoal (page)
  _1100: '1100: Set goal ownership radio',
  _1101: '1101: Set goal ownership',
  _1102: '1102: Set goal contact ID',
  _1103: '1103: Set goal secondary contact ID',
  _1104: '1104: Set goal owner name',
  _1105: '1105: Set goal type',
  _1106: '1106: Set goal form name',

  // ============================================
  // GOAL AMOUNTS (3600-3649)
  // ============================================

  // features/goals/Goals/GoalAmounts.tsx
  // [GoalAmounts.tsx] -> [GoalFormHelper.tsx] -> [GoalForm.tsx] -> [CreateGoal.tsx] CreateGoal (page)
  _3600: '3600: Set goal target amount',
  _3601: '3601: Set goal rate value',
  _3602: '3602: Set drawdown rate value',

  // ============================================
  // BULK ADMIN (1200-1299)
  // ============================================

  // features/bulkAdmin/BulkAdminModal.tsx
  // [BulkAdminModal.tsx] BulkAdmin (standalone feature)
  _1211: '1211: Bulk Admin - Clear selected actions',
  // features/bulkAdmin/BulkAdminPageHelpers.tsx
  // [BulkAdminPageHelpers.tsx] BulkAdmin (standalone feature)
  _1202: '1202: Set bulk admin active filter',
  _1205: '1205: Open bulk actions modal',
  _1206: '1206: Update bulk admin cursors (pagination)',

  // features/bulkAdmin/columns.tsx
  // [columns.tsx] BulkAdmin (standalone feature)
  _1203: '1203: Update bulk admin search term',
  _1204: '1204: Reset bulk admin cursors',
  // features/bulkAdmin/BulkFiltersModal.tsx
  // [BulkFiltersModal.tsx] BulkAdmin (standalone feature)
  _1207: '1207: Set bulk admin next review date range',
  // features/bulkAdmin/columns.tsx
  // [columns.tsx] BulkAdmin (standalone feature)
  _1208: '1208: Set bulk admin order by',
  _1209: '1209: Set bulk admin order direction',
  // features/bulkAdmin/utils.ts
  // [utils.ts] BulkAdmin (standalone feature)
  _1200: '1200: Clear bulk admin field value',
  _1201: '1201: Remove bulk admin date filter',

  // ============================================
  // TASKS (1300-1399)
  // ============================================

  // features/tasks/CreateTask/TaskEntityField.tsx
  // [TaskEntityField.tsx] Tasks (standalone feature)
  _1306: '1306: Set task regarding ID',
  // features/tasks/CreateTask/TaskEntityField.tsx
  // features/tasks/CreateTask/TasksForm.tsx
  // [TaskEntityField.tsx] / [TasksForm.tsx] Tasks (standalone feature)
  _1301: '1301: Set task selected entity type details',
  // features/tasks/CreateTask/TaskList.tsx
  // [TaskList.tsx] Tasks (standalone feature)
  _1307: '1307: Set task subgroup ID',
  // features/tasks/CreateTask/TasksForm.tsx
  // [TasksForm.tsx] Tasks (standalone feature)
  _1300: '1300: Set task deadline',
  _1302: '1302: Set task entity option',
  _1303: '1303: Set task selected entity type',
  _1304: '1304: Set task open accordion group',
  _1305: '1305: Set task contact',

  // ============================================
  // CLIENT DOCUMENTS (1400-1499)
  // ============================================

  // pages/ClientDocumentsPageV2/FileUploadFormV2.tsx
  // [FileUploadFormV2.tsx] ClientDocuments (page)
  _1400: '1400: Set document contact name 2 (reset)',
  _1401: '1401: Set document date picker (reset)',
  _1402: '1402: Set document files',
  _1403: '1403: Set document contact ID 1',
  _1404: '1404: Set document contact ID 2',
  _1405: '1405: Set document plan number status',
  _1406: '1406: Set document group',
  // pages/ClientDocumentsPageV2/utilsV2.tsx
  // [utilsV2.tsx] ClientDocuments (page)
  _1407: '1407: Set document files (utils)',

  // ============================================
  // ADDRESS / LEAD (1600-1699)
  // ============================================

  // pages/AddExtAccountPage/AddAccountBasic.tsx
  // [AddAccountBasic.tsx] AddExtAccount (page)
  _1605: '1605: Set lead adviser',
  // pages/AddExtAccountPage/AddExtAccountAddress.tsx
  // [AddExtAccountAddress.tsx] AddExtAccount (page)
  _1600: '1600: Set address line 1',
  _1601: '1601: Set address line 2',
  _1602: '1602: Set town',
  _1603: '1603: Set postcode',
  _1604: '1604: Set county',
  // pages/LeadsPage/LeadBasic.tsx
  // [LeadBasic.tsx] Leads (page)
  _1611: '1611: Remove secondary lead',

  // ============================================
  // ATR (1700-1749)
  // ============================================

  // components/AttitudeToRisk/AtrInputs.tsx
  // [AtrInputs.tsx] ATR (standalone component)
  _1700: '1700: Set ATR action',
  // components/AttitudeToRisk/AtrInputs.tsx
  // components/AttitudeToRisk/ScoreSlider.tsx
  // [AtrInputs.tsx] / [ScoreSlider.tsx] ATR (standalone component)
  _1701: '1701: Set ATR amended value',

  // ============================================
  // POSTCURSOR (1900-1999)
  // ============================================

  // pages/PostcursorPage/HeaderVulnerabilityFields.tsx
  // [HeaderVulnerabilityFields.tsx] Postcursor (page)
  _1900: '1900: Reset long term vulnerability types',
  _1901: '1901: Reset event vulnerability types',
  _1902: '1902: Reset special care reasons',
  // pages/PostcursorPage/PostcursorWizardSummary.tsx
  // [PostcursorWizardSummary.tsx] Postcursor (page)
  _1903: '1903: Set postcursor step',

  // ============================================
  // REPORT PACK DASHBOARD (2000-2099)
  // ============================================

  // pages/ReportPackDashboardPage/ReportPackDashboardFiltersModal.tsx
  // [ReportPackDashboardFiltersModal.tsx] ReportPackDashboard (page)
  _2005: '2005: Report Pack Dashboard - Deselect filtered advisers',
  _2006: '2006: Report Pack Dashboard - Select filtered advisers',
  _2007: '2007: Report Pack Dashboard - Clear advisers on cancel',
  // pages/ReportPackDashboardPage/ReportPackDashboardStatusFiltersModal.tsx
  // [ReportPackDashboardStatusFiltersModal.tsx] ReportPackDashboard (page)
  _2008: '2008: Report Pack Dashboard - Deselect all statuses',
  _2009: '2009: Report Pack Dashboard - Select all statuses',
  _2010: '2010: Report Pack Dashboard - Clear statuses on cancel',

  // ============================================
  // REPORT PACK SINGLE (2100-2199)
  // ============================================

  // pages/ReportPackPage/DeclinedOptions.tsx
  // [DeclinedOptions.tsx] ReportPack (page)
  _2100: '2100: Declined Options - Set ATR Type',
  _2101: '2101: Declined Options - Set Months',
  // pages/ReportPackPage/NoActionOptions.tsx
  // [NoActionOptions.tsx] ReportPack (page)
  _2102: '2102: No Action Options - Set Client Type',
  _2103: '2103: No Action Options - Set ATR Type',
  _2104: '2104: No Action Options - Set Include Options',
  // pages/ReportPackPage/ReportPackFile.tsx
  // [ReportPackFile.tsx] ReportPack (page)
  _2105: '2105: Report Pack File - Set Template HTML',
  // pages/ReportPackPage/UncontactableOptions.tsx
  // [UncontactableOptions.tsx] ReportPack (page)
  _2106: '2106: Uncontactable Options - Set ATR Type',
  _2107: '2107: Uncontactable Options - Set Months',
  // pages/ReportPackPage/UploadDocumentReportPack.tsx
  // [UploadDocumentReportPack.tsx] ReportPack (page)
  _2108: '2108: Upload Document - Set Selected Generic Forms',
  _2109: '2109: Upload Document - Set Files',

  // ============================================
  // WIZARD UTILS (shared) (3200-3249)
  // ============================================
  // components/PrecursorForm/PrecursorWizardSummary.tsx
  // [PrecursorWizardSummary.tsx] Wizard (shared component)
  _3204: '3204: From wizard summary, user clicks value and display goes to that step',
  // components/Wizard/Wizard.tsx
  // [Wizard.tsx] Wizard (shared component)
  _3200: '3200: Set wizard step (skip)',
  _3201: '3201: Set wizard step (previous)',
  _3202: '3202: Set wizard step (auto-advance)',
  _3203: '3203: Set wizard step (summary)',

  // ============================================
  // COMMON COMPONENTS (4700-4799)
  // ============================================
  // components/AutoForm/AutoFieldNew.tsx
  // [AutoFieldNew.tsx] AutoForm (shared component)
  _4701: '4701: Wizard: user typed input',
  // components/AutoForm/AutoFieldNew.tsx
  // components/Common/SpecialCharacterTextField.tsx
  // [AutoFieldNew.tsx] / [SpecialCharacterTextField.tsx] Common (shared component)
  _4700: '4700: User typed input',

  // ============================================
  // REPORT PACK FORMS (2200-2249)
  // ============================================
  // pages/ReportPackPage/ISAApplicationForm.tsx
  _2200: '2200: Report Pack ISA - Set default tax year',
  // pages/ReportPackPage/JISAApplicationForm.tsx
  _2201: '2201: Report Pack JISA - Set default tax year',
  // pages/ReportPackPage/DependantForm.tsx
  _2202: '2202: Report Pack Dependant - Clean child address (remove newlines)',
  _2203: '2203: Report Pack Dependant - Load dependant details from contact',

  // ============================================
  // ANNUAL REVIEWS (4800-4849)
  // ============================================
  // pages/AnnualReviewsPage/components/ConfirmInvitationModal.tsx
  _4800: '4800: Annual Reviews - Set initial host from review owner',

  // ============================================
  // FILE UPLOAD (1450-1499)
  // ============================================
  // pages/ClientDocumentsPageV2/FileUploadFormV2.tsx
  _1450: '1450: File Upload - Reset form to initial values',

  // ============================================
  // ADD ACCOUNT (4550-4599)
  // ============================================
  // pages/AddExtAccountPage/AddAccountBasic.tsx
  _4550: '4550: Add Account - Merge values and set single/joint',

  // ============================================
  // PRECURSOR (3250-3299)
  // ============================================
  // components/PrecursorForm/PrecursorForm.tsx
  _3250: '3250: Precursor Debug - Set planned for values',
  _3251: '3251: Precursor Debug - Set happened today values',

  // ============================================
  // PERMISSIONS FILTER (4850-4899)
  // ============================================
  // components/PermissionsFilterDialog/PermissionsFilterDialog.tsx
  _4850: '4850: Permissions Filter - Reset to initial state',
} as const;

export type ReccFormUpdateKey = keyof typeof UPDATES;
export type ReccFormUpdateValue = typeof UPDATES[ReccFormUpdateKey];
